import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, FLink, LoadingIndicator } from '@components';
import { BeneficiariosService } from '@services';
import { toast } from 'react-toastify';
import update from 'immutability-helper';
import './styles.css';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addYears, isPast, parse } from 'date-fns';
import { Beneficiario } from './beneficiario';
import { opcoesTelaBeneficiarios } from '../../../../store/modules/simulacaoBeneficio/actions';
import { ID_PERCENT_SALDO, ID_TEMPORARIO, ID_VITALICIO } from '../Renda/utils';
import {
  RESULTADO_BENEFICIOS_ABSOLUTE_PATH,
  RESULTADO_CONVERSAO_ABSOLUTE_PATH,
} from '../../../../common/utils/paths';

export const Beneficiarios = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [beneficiarios, setBeneficiarios] = useState([]);
  const [disabledCheckbox, setDisabledCheckbox] = useState(false);
  const users = useSelector((state) => state.user);
  const dadosRenda = useSelector((state) => state.simulacaoBeneficio);

  const getBeneficiarios = useCallback(async () => {
    const service = new BeneficiariosService();
    await service
      .getBeneficiarios(users.matricula, users.plano)
      .then((dados) => {
        if (dados.data.ObterBeneficiariosParticipanteResult === null) {
          setLoading(false);
          return;
        }
        const dadosBeneficiarios =
          dados.data.ObterBeneficiariosParticipanteResult.Beneficiario;
        const dadosBeneficiariosModel = [];

        try {
          if (Array.isArray(dadosBeneficiarios)) {
            dadosBeneficiarios.forEach((item) => {
              const nomeSegregado = item.CodigoNome.split(' - ');
              const itemAux = {
                id: nomeSegregado[0],
                nome: nomeSegregado[1],
                nascimento: item.DataNascimento,
                parentesco: item.Parentesco,
                situacao: item.Situacao,
              };
              dadosBeneficiariosModel.push(itemAux);
            });
          } else {
            const nomeSegregado = dadosBeneficiarios?.CodigoNome.split(' - ');
            // valida se existe algum registro
            if (nomeSegregado) {
              dadosBeneficiariosModel.push({
                id: nomeSegregado[0],
                nome: nomeSegregado[1],
                nascimento: dadosBeneficiarios.DataNascimento,
                parentesco: dadosBeneficiarios.Parentesco,
                situacao: dadosBeneficiarios.Situacao,
              });
            }
          }
        } catch (error) {
          toast.error('Erro ao recuperar os beneficiarios');
          console.error('Erro ao recuperar beneficiarios: ', error);
        }

        setBeneficiarios(dadosBeneficiariosModel);
        setLoading(false);
      })
      .catch((err) => {
        toast.error('Erro ao recuperar os dados');
        console.error(err);
      });
  }, [users.matricula, users.plano]);

  const [beneficiariosChecked, setBeneficiariosChecked] = useState([]);

  const simular = () => {
    dispatch(opcoesTelaBeneficiarios(beneficiariosChecked));
    if (!dadosRenda.telaSimulacaoConversao) {
      navigate(RESULTADO_BENEFICIOS_ABSOLUTE_PATH);
    } else {
      navigate(RESULTADO_CONVERSAO_ABSOLUTE_PATH);
    }
  };

  const semBeneficiarios = () => {
    return <div>nenhum beneficiario</div>;
  };

  const check = useCallback(
    (values) => {
      const arr = beneficiariosChecked;
      arr.push(values);
      setBeneficiariosChecked(arr);
    },
    [beneficiariosChecked]
  );

  const uncheck = (values) => {
    const arr = update(beneficiariosChecked, {
      $splice: [[beneficiariosChecked.indexOf(values), 1]],
    });
    setBeneficiariosChecked(arr);
  };

  const checkAll = useCallback(() => {
    if (
      dadosRenda.tipoRendaMensal === ID_PERCENT_SALDO ||
      dadosRenda.tipoRendaMensal === ID_TEMPORARIO ||
      dadosRenda.percentualrcm === 0
    ) {
      beneficiarios.forEach((item) => {
        check(item);
      });
      setDisabledCheckbox(true);
    }
  }, [
    beneficiarios,
    check,
    dadosRenda.tipoRendaMensal,
    dadosRenda.percentualrcm,
  ]);

  useEffect(() => {
    getBeneficiarios();
  }, [getBeneficiarios]);

  useEffect(() => {
    checkAll();
  }, [checkAll]);

  return !loading ? (
    <div className="card">
      <div className="card-body pb-0">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(-1)}
        >
          voltar
        </FLink>
        {dadosRenda.tipoRendaMensal === ID_VITALICIO &&
        dadosRenda.percentualrcm === 0 ? (
          <h3 className="ts-18 fw-bold mb-4">
            Benefício sem pensão. Não serão considerados beneficiários na
            análise.
          </h3>
        ) : (
          <div className="row">
            {disabledCheckbox ? (
              <h3 className="ts-18 fw-bold mb-4">
                Beneficiários considerados na análise{' '}
              </h3>
            ) : (
              <h3 className="ts-18 fw-bold mb-4">Escolha os beneficiários</h3>
            )}

            {beneficiarios.length > 0
              ? beneficiarios.map((b) => {
                  // Regra do parentesco
                  const isVitalicio =
                    dadosRenda.tipoRendaMensal === Number(ID_VITALICIO);

                  const parsedDataNascimento = parse(
                    b.nascimento,
                    'dd/MM/yyyy',
                    new Date()
                  );

                  const dataNascimentoMais24Anos = addYears(
                    parsedDataNascimento,
                    24
                  );

                  const filhoMaiorDe24Anos =
                    isPast(dataNascimentoMais24Anos) &&
                    b.parentesco.indexOf('Filh') >= 0 &&
                    b.situacao !== 'Inválido';

                  return (
                    <Fragment key={b.id}>
                      <div className="col-md-12 col-lg-6 mb-4">
                        <Beneficiario
                          checkedArray={beneficiariosChecked}
                          onCheck={check}
                          onUnchecked={uncheck}
                          values={b}
                          disabledCheckbox={
                            disabledCheckbox ||
                            (isVitalicio && filhoMaiorDe24Anos)
                          }
                        />
                      </div>
                    </Fragment>
                  );
                })
              : semBeneficiarios()}
          </div>
        )}
      </div>
      <div className="card-footer">
        <hr />
        <div className="row">
          <div className="ms-auto col-12 col-md-6">
            <Button className="mt-3" onClick={simular}>
              Simular
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <LoadingIndicator />
  );
};
